<template>
<div class="vx-col w-full mb-base" id="account-info-col-1">
    <div class="vx-col flex-1">

        <ul>
            <li v-for="(item, index) in reportItems" :key="index" class="mt-5 flex items-center justify-between">
                <!-- <div class="vx-row"> -->
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-3" >
                        <vs-checkbox v-model="selected[index]" :vs-value="item.value" class="ml-2">{{ item.reportName }}</vs-checkbox>
                    </div>
                    <div v-show="index === 0 ? true: false" class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full " >
                            <span  class="text-sm">Month</span><span style="color:red">*</span>
                                <v-select v-validate="'required'"  name="monthName" v-model="monthName" label="monthName"  :options="getActiveMonths" placeholder="Please Select"/>
                            <span class="text-danger">{{ errors.first('step-1.monthName') }}</span>
                    </div>
                    <div v-show="index === 1 ? true: false" class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full " >
                        <span  class="text-sm">Year</span><span style="color:red">*</span>
                            <v-select v-validate="'required'"  name="yearToDate" v-model="yearScope"   :options="generateArrayOfYears" placeholder="Please Select"/>
                        <span class="text-danger">{{ errors.first('step-1.yearToDate') }}</span>
                    </div>
                    <!-- </div> -->
                    <div v-show="selected[index] === 'PayrollGrossPay-History'" class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" >
                        <span class="text-sm">Employee</span><span style="color:red">*</span>
                        <v-select
                            v-validate="requiresEmployeeSelection ? 'required' : ''"
                            v-model="selectedEmployee"
                            name="employee"
                            :options="employees"
                            :get-option-label="getEmployeeLabel"
                            placeholder="Please Select"
                        />
                        <span class="text-danger">{{ errors.first('employee') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                <!-- </div> -->
                <!-- <span>{{selected }}</span> -->
            </li>
        </ul>

    </div>
    <div class="flex justify-between flex-wrap mt-5">
        <span/>
        <vs-button @click="onSetPasswordToOpen()" color="success" type="filled" icon-pack="feather" icon="icon-download">Generate Reports</vs-button>
    </div>

    </div>
</template>

<script>
import moment from 'moment'
import vSelect from 'vue-select'

import axios from '@/axios.js'
import Swal from 'sweetalert2'

export default {
    props: {
        createPayroll: {
            type: Array,
            required: false
        },

    },
    data() {
        return {
            counter         :0,
            percentage      :[0],
            creditDate: moment().format('DD MMM yyyy'),
            payOutDate: [],
            monthName: null,
            yearScope: new Date().getFullYear(),
            selectedEmployee: null,

            reportItems: [
                { value: 'PayrollSSS-Monthly', reportName: 'SSS Monthly Reports'},
                { value: 'PayrollPhilhealth-Monthly', reportName: 'Philheath Monthly Reports'},
                { value: 'PayrollPagibig-Monthly', reportName: 'Pagibig Monthly Reports'},
                { value: 'PayrollLoanPayments-Monthly', reportName: 'Loan Payments'},
                { value: 'PayrollDeductions-Monthly', reportName: 'Pagibig MP2'},
                { value: 'PayrollGrossPay-History', reportName: 'GrossPay History'},
                { value: 'PayrollWithholdingTax-Monthly', reportName: 'Total Compensation - with WHTax'},
                { value: 'PayrollWithholdingTaxZero-Monthly', reportName: 'Total Compensation - Zero Whtax'},
                { value: 'GrossPay', reportName: 'Gross Pay - Excel'},
                { value: 'MonthlySSS', reportName: 'SSS Monthly - Excel'},
                { value: 'MonthlyPhilHealth', reportName: 'PhilHealth Monthly - Excel'},
                { value: 'MonthlyPagIbig', reportName: 'Pag-IBIG Monthly - Excel'},
                { value: 'MonthlyLoan', reportName: 'Loan Monthly - Excel'},
                { value: 'MonthlyTax', reportName: 'Tax Monthly - Excel'}

            ],
            // selected:[ "PayrollEarnings", "PayrollDeductions", "PayrollLoans", "PayrollBankRemittance", "PayrollBankAdvise", "PayrollRegister", "PayrollRegisterProjectStaff", "PayrollProoflist"],
            selected:[],
            passwordToOpen:''


        }
    },
    created() {
      this.$store.dispatch('payroll/getAllCreatePayroll')
            .then(() => {
                this.$vs.loading.close()
            })
            .catch((err) => {
                this.$vs.loading.close()
                this.$alert(err.message, 'Error', 'error')
            })
    },
    computed: {
        getAllCreatePayroll() {
            return this.$store.state.payroll.getAllCreatePayroll
        },
        getActiveMonths() {
            let createPayroll = this.getAllCreatePayroll
            const unique = [...new Set(createPayroll.map(item => item.monthName))]
            return unique

        },
        getAllPayOutDate() {
            let p = this.getAllCreatePayroll
            let payOutDate = []
            p.forEach(d => {
                payOutDate.push(Object.assign(d, { payOutDate: moment(d.payOutDate).format('YYYY-MM-DD')}))
            })
            return payOutDate
        },
        getAllLogHours() {
            return this.$store.state.payroll.getAllLogHours
        },
        employees() {
            return this.$store.state.hrms.allEmployee
        },
        requiresEmployeeSelection() {
            return this.selected.includes('PayrollGrossPay-History')
        },
        generateArrayOfYears() {
            let createPayroll = this.getAllCreatePayroll
            const years = [...new Set(createPayroll.map(item => item.calendarYear))]
            return years
        },
        tenantName() {
            return (id) => this.$store.getters['tenants/tenantName'](id)
        },
        getMonthValue() {
            return (monthName) => {
                if(monthName == null || monthName === '') return ''

                const normalizedMonthName = monthName.toString().trim()
                const monthNumber = Number(normalizedMonthName)
                if(!Number.isNaN(monthNumber)) return monthNumber.toString()

                const months = {
                    january: 1,
                    february: 2,
                    march: 3,
                    april: 4,
                    may: 5,
                    june: 6,
                    july: 7,
                    august: 8,
                    september: 9,
                    october: 10,
                    november: 11,
                    december: 12
                }

                const monthValue = months[normalizedMonthName.toLowerCase()]
                return monthValue ? monthValue.toString() : ''
            }
        },
        getMonthlyPayroll() {
            return (monthName, yearScope) => {
                const monthValue = this.getMonthValue(monthName)
                return this.getAllCreatePayroll.find(item =>
                    this.getMonthValue(item.monthName) == monthValue && item.calendarYear == yearScope
                )
            }
        }
    },
    methods: {
        getEmployeeLabel(employee) {
            if(!employee) return ''

            const employeeCode = employee.employeeCode || ''
            const employeeName = employee.fullName || [employee.firstName, employee.lastName].filter(Boolean).join(' ')

            return [employeeCode, employeeName].filter(Boolean).join(' - ')
        },
        onGenerateReports() {


            this.percentageReport = [0]
            this.counterReports = 0
            let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId)

            if(this.selected.filter(Boolean).length === 0) {
                this.$alert('Select at least one report to generate.', 'Report Required', 'info')
                return
            }

            if(this.requiresEmployeeSelection && (!this.selectedEmployee || !this.selectedEmployee.id)) {
                this.$alert('Please select an employee for the GrossPay History report.', 'Employee Required', 'info')
                return
            }

            const selectedPayroll = this.getMonthlyPayroll(this.monthName, this.yearScope)
            if(!selectedPayroll) {
                this.$alert('No payroll was found for the selected month and year.', 'Payroll Not Found', 'error')
                return
            }

            const uid = this.requiresEmployeeSelection ? this.selectedEmployee.id : this.$store.state.AppActiveUser.uid
            const employeeCode = this.requiresEmployeeSelection ? this.selectedEmployee.employeeCode : ''
            //Export Report in ZIP File
            const data = {
                serverName: tenant.secretKey,
                dbName: tenant.apiKey,
                username: '',
                password: '',
                companyCode: tenant.code,
                companyName: tenant.name,
                address: tenant.address,
                createPayrollId: selectedPayroll ? selectedPayroll.createPayrollId : 0,
                printedBy: this.$store.state.AppActiveUser.uid,
                reportName: this.selected.filter(Boolean),
                payOutDate: selectedPayroll ? moment(selectedPayroll.payOutDate).format('YYYYMMDD') : '',
                creditDate: selectedPayroll ? moment(selectedPayroll.payOutDate).format('YYYYMMDD') : '',
                passwordToOpen: this.passwordToOpen,
                userId: [uid],
                monthName: this.getMonthValue(this.monthName),
                yearScope: this.yearScope == null ? '' : this.yearScope.toString(),
                reportType: 'MONTHLY',
                dbReportName: '',
                dbCalendarYear: this.yearScope == null ? '' : this.yearScope.toString(),
                dbMonthName: this.getMonthValue(this.monthName),
                dbEmployeeCode: employeeCode,
                employeeStatusLookup: 0,
                employmentStatusLookup: 0,
                department: 0
            }

            // this.$vs.loading()
            this.$store.dispatch('payroll/GenerateReports', data)
            .then(() => {
                var zipFileName = tenant.code + '_MONTHLY.zip'
                // var zipFileName = tenant.code + '_' + moment(this.createPayroll.payOutDate).format('YYYYMMDD') + '.zip'
                // var pDate = moment(this.createPayroll.payOutDate).format('YYYYMMDD')
                axios.get(`/api/reports/OtherReports?dbName=${tenant.code}&fileName=${zipFileName}&reportType=MONTHLY&monthName=${this.monthName}&yearScope=${this.yearScope}`
                ,{ reportProgress: true, responseType: 'blob' })
                    .then((response) => {
                            this.$vs.loading.close()
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', zipFileName);
                            document.body.appendChild(link);
                            link.click();

                            Swal.fire({ title: 'Done', html: 'Reports Generated', icon:'success', timer: 2000, timerProgressBar: true,})
                    })
                    .catch((error) => {
                        this.$alert(error.message, 'Error', 'error')
                    })
            })
        },
        onSetPasswordToOpen() {
            if(this.requiresEmployeeSelection && (!this.selectedEmployee || !this.selectedEmployee.id)) {
                this.$alert('Please select an employee for the GrossPay History report.', 'Employee Required', 'info')
                return
            }

            Swal.fire({
                    title: 'Set Password',
                    input: 'password',
                    inputLabel: 'Password',
                    inputPlaceholder: 'Max of 10 characters',
                    inputAttributes: {
                    maxlength: 10,
                    autocapitalize: 'off',
                    autocorrect: 'off'
                }
            })
            .then((t) => {
                // console.log(t.value)
                this.passwordToOpen = t.value
                if(t.value == '') {
                    this.$alert("This is an important file and must have a password ", "Password Required", "info")
                } else {
                    this.onOpenWaitingDialog()
                }
            })

        },
        onOpenWaitingDialog() {
            Swal.fire({
                title: 'Generating Reports!',
                html: 'Please wait while report is generating...',
                timer: 2000,
                showConfirmButton: false,
                didOpen: () => {
                    this.onGenerateReports()
                },
                }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    // console.log('I was closed by the timer')
                }
            })
        }
    },
    components: {
        'v-select': vSelect
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
